export enum RelacaoImovelAdicionalTipo {
  LOCADO = 'LOCADO',
  EMPRESTADO = 'EMPRESTADO',
  CEDIDO = 'CEDIDO',
  OUTRO = 'OUTRO',
}
